module.exports = __webpack_public_path__ + "img/Single vent-1.dbbe4aa3.svg";